import { render, staticRenderFns } from "./village.vue?vue&type=template&id=d2019ae6&scoped=true&"
import script from "./village.vue?vue&type=script&lang=js&"
export * from "./village.vue?vue&type=script&lang=js&"
import style0 from "./village.vue?vue&type=style&index=0&id=d2019ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2019ae6",
  null
  
)

export default component.exports